import { Button } from "@repo/ui/components/ui/button";
import { CollapsibleTrigger } from "@repo/ui/components/ui/collapsible";
import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";

/**
 * The header of a collapsible region inside a charting card. No fill: the
 * region sits in an `overflow-hidden` panel, and the pull-left that keeps the
 * chevron on the content edge would clip a ghost button's rounded corners.
 */
export function ChartSectionTrigger({ children }: { children: ReactNode }) {
  return (
    <CollapsibleTrigger
      render={
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="group -ml-2.5 hover:bg-transparent aria-expanded:bg-transparent dark:hover:bg-transparent"
        />
      }
    >
      <ChevronRight className="size-4 text-muted-foreground transition-transform group-data-[panel-open]:rotate-90" />
      {children}
    </CollapsibleTrigger>
  );
}
